import { CircleCheck } from "lucide-react";

type CompletedBadgeProps = {
  label: string;
};

export const CompletedBadge = ({ label }: CompletedBadgeProps) => (
  <div className="flex items-center gap-1.5 rounded-full bg-cede-secondary/[0.13] px-3.5 py-1.5">
    <CircleCheck className="h-4 w-4 text-cede-secondary" />
    <span className="text-xs font-semibold text-cede-secondary">{label}</span>
  </div>
);
